import get from 'lodash/fp/get'
import * as Elasticsearch from '../../../elasticsearch'
import * as Types from './types'

const toTopArticle = (bucket: any): Types.TopTopic => {
  const topicName = get('key', bucket)
  const topicCount = get(Elasticsearch.AggFieldNames.DocumentCount, bucket)
  return {
    count: topicCount,
    value: topicName,
  }
}

export const getTopTopics = (payload: any): Types.TopTopic[] => {
  return get('aggregations.text.buckets', payload).map((bucket: any) => toTopArticle(bucket))
}



// WEBPACK FOOTER //
// ./src/pages/reports/top-topics/utils.ts